import { Checkbox, Col } from '@ksyos/design-system';
import type { IAfwijkingenWithOdAndOs } from '@common/interfaces/ophthalmology/OorkAndOcrk/oorkV1DiagnosticReportCustomControlData';

interface IAfwijkingenInputCheckboxOsAndOdProps<K> {
    afwijkingen: K;
    handleChangeAfwijkingen: (key: keyof K, value: K[keyof K]) => Promise<void>;
    key_od: keyof K;
    key_os: keyof K;
}

export function AfwijkingenInputCheckboxOsAndOd(props: IAfwijkingenInputCheckboxOsAndOdProps<IAfwijkingenWithOdAndOs>) {
    const { key_od, key_os, afwijkingen, handleChangeAfwijkingen } = props;

    return (
        <>
            <Col span={2}>
                <Checkbox
                    checked={afwijkingen[key_od]}
                    className={`automation-${key_od}`}
                    label="OD"
                    onChange={async (event) => await handleChange(event, key_od)}
                />
            </Col>
            <Col span={7}>
                <Checkbox
                    checked={afwijkingen[key_os]}
                    className={`automation-${key_os}`}
                    label="OS"
                    onChange={async (event) => await handleChange(event, key_os)}
                />
            </Col>
        </>
    );

    async function handleChange(event: React.ChangeEvent<HTMLInputElement>, key: keyof IAfwijkingenWithOdAndOs) {
        await handleChangeAfwijkingen(key, event.target.checked);
    }
}
